"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EyeOpened = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var EyeOpened = function EyeOpened(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8c0-1.5-3.582-5-8-5S0 6.5 0 8s3.582 5 8 5 8-3.5 8-5zm-2.08 0a2.97 2.97 0 00-.148-.213c-.27-.36-.708-.804-1.299-1.237a8.421 8.421 0 00-1.023-.643 3.5 3.5 0 11-6.9 0 8.418 8.418 0 00-1.024.643c-.59.433-1.028.877-1.298 1.237A2.931 2.931 0 002.08 8c.035.057.083.128.147.213.27.36.708.804 1.298 1.237C4.716 10.323 6.311 11 8 11c1.69 0 3.284-.677 4.473-1.55.59-.433 1.029-.877 1.3-1.237A2.97 2.97 0 0013.918 8zM7.5 7.5a1 1 0 100-2 1 1 0 000 2z",
    fill: "currentColor"
  }));
};

exports.EyeOpened = EyeOpened;
var _default = EyeOpened;
exports.default = _default;